<template>
  <div class="link-bot-drawer__actions">
    <button
      type="button"
      class="link-bot-drawer__btn link-bot-drawer__btn--cancel"
      :data-testid="`${dataTestId}__cancel-btn`"
      @click="$emit('cancel')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="link-bot-drawer__btn link-bot-drawer__btn--primary"
      :disabled="primaryDisabled || loading"
      :data-testid="`${dataTestId}__submit-btn`"
      @click="$emit('submit')"
    >
      {{ primaryLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LinkBotDrawerActions',

  props: {
    primaryLabel: {
      type: String,
      default: 'Link',
    },
    primaryDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataTestId: {
      type: String,
      default: 'link-bot-drawer',
    },
  },
};
</script>
